export const ageVerification = {
  namespaced: true,
  state: {
    ageVerificationService: null,
    isVerified: false,
    isInitialized: false,
    showAdultContentBlurredAlert: false,
  },
  mutations: {
    async init(state, { ageVerificationService, keepAlive } = {}) {
      state.isInitialized = true
      state.ageVerificationService = ageVerificationService
      state.isVerified = await state.ageVerificationService.isVerified()

      if (keepAlive && state.isVerified && state.ageVerificationService.bumpKeepAliveCheckpoint()) {
        await state.ageVerificationService.keepAlive()
      }
    },
    async verifyAge(state) {
      let session = null

      if (state.ageVerificationService.sessionId) {
        const onboardingUrl = await state.ageVerificationService.getOnboardingUrl()
        if (onboardingUrl) {
          session = { onboardingUrl }
        }
      }

      if (!session) {
        session = await state.ageVerificationService.createSession()
      }

      if (!session) {
        console.error('Failed to create session')
        return
      }

      window.location.href = session.onboardingUrl
    },
    showAdultContentBlurredAlert(state) {
      state.showAdultContentBlurredAlert = true
    },
  },
  actions: {
    init(context, initialState) {
      context.commit('init', initialState)
    },
    verifyAge(context) {
      context.commit('verifyAge')
    },
    showAdultContentBlurredAlert(context) {
      context.commit('showAdultContentBlurredAlert')
    },
  },
  getters: {
    isVerified(state) {
      return state.isVerified
    },
    ageVerificationService(state) {
      return state.ageVerificationService
    },
    isInitialized(state) {
      return state.isInitialized
    },
    showAdultContentBlurredAlert(state) {
      return state.showAdultContentBlurredAlert
    },
  },
}
